import { ParseError } from "@/repositories/shared/errors/parseError";
import {
  HttpVerifyEmployeeNumber,
  IVerifyEmployeeNumberParser,
} from "../userRepository.types";
import { ok, err, Result } from "neverthrow";

import { injectable } from "inversify";
import { IUserVerifyEmployeeNumber } from "@/domain/entities/user";

@injectable()
export class VerifyEmployeeNumber implements IVerifyEmployeeNumberParser {
  toDomain(
    data: HttpVerifyEmployeeNumber
  ): Result<IUserVerifyEmployeeNumber, ParseError> {
    try {
      const userVerifyEmployeeNumber: IUserVerifyEmployeeNumber = {
        name: data.name,
      };

      return ok(userVerifyEmployeeNumber);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
